module.exports = __webpack_public_path__ + "img/geted@2x.d7e6c2e5.png";